import React from 'react';
import { Card, Table, Typography, Statistic, Row, Col } from 'antd';
import { DollarOutlined, RiseOutlined, FallOutlined } from '@ant-design/icons';

import { dashboardService, ExchangeRateItem } from '../../services/dashboardService';
import { Spin } from 'antd';
import dayjs from 'dayjs';

const { Text } = Typography;

export const ExchangeRateCard: React.FC = () => {
    const [loading, setLoading] = React.useState(true);
    const [rates, setRates] = React.useState<ExchangeRateItem[]>([]);
    const [lastUpdated, setLastUpdated] = React.useState<string>('');

    React.useEffect(() => {
        const fetchRates = async () => {
            try {
                const data = await dashboardService.getExchangeRates();
                setRates(data);
                if (data.length > 0) {
                    setLastUpdated(data[0].date);
                }
            } catch (error) {
                console.error('Failed to fetch exchange rates:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchRates();
    }, []);

    return (
        <Card
            title={<span><DollarOutlined style={{ marginRight: 8 }} /> 汇率参考</span>}
            className="dashboard-card exchange-rate-card"
            extra={<Text type="secondary" style={{ fontSize: 12 }}>更新: {lastUpdated || '加载中...'}</Text>}
        >
            {loading ? (
                <div style={{ textAlign: 'center', padding: '20px' }}><Spin /></div>
            ) : (
                <div className="exchange-rate-list">
                    {rates.map(item => (
                        <div key={item.currency} className="exchange-rate-item">
                            <div className="rate-currency">{item.currency}/CNY</div>
                            <div className="rate-value">{Number(item.rate).toFixed(4)}</div>
                            <div className={`rate-change ${Number(item.change_percent) >= 0 ? 'up' : 'down'}`}>
                                {Number(item.change_percent) >= 0 ? <RiseOutlined /> : <FallOutlined />} {Math.abs(Number(item.change_percent))}%
                            </div>
                        </div>
                    ))}
                </div>
            )}
            <div className="exchange-rate-calculator-entry" style={{ padding: '12px 0 0', borderTop: '1px solid #f0f0f0', marginTop: 12 }}>
                <Text type="secondary" style={{ fontSize: 12 }}>* 数据仅供参考，实操请以银行牌价为准</Text>
            </div>
        </Card>
    );
};
